import api from './AxiosInstance';

export class EtatComptaService {
 
  

  listEtatComptaExport = async (dataExport) => {
    try {
      const response = await api.post(`/Compta/Export/list`,dataExport,{

      });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    
    }
  };


exportCompta = async (codeExport) => {
  try {
    // Appel API GET avec Axios à l'endpoint spécifié, demandant une réponse sous forme de blob (fichier binaire).
    const response = await api.get(`/Compta/ExportEtatFin/${codeExport}`, { responseType: 'blob' });

    // Création d'une URL temporaire pour le blob reçu, nécessaire pour le téléchargement du fichier.
    const url = window.URL.createObjectURL(new Blob([response.data]));

    // Création dynamiquement d'un élément 'a' (lien) dans le DOM.
    const link = document.createElement('a');
    // Définition de l'URL du lien sur l'URL du blob créée précédemment.
    link.href = url;
    // Définition de l'attribut 'download' du lien pour suggérer un nom de fichier lors du téléchargement, ajoutant '.xlsx' pour spécifier le format Excel.
    link.setAttribute('download', `${codeExport}.xlsx`);

    // Ajout du lien créé au corps du document pour le rendre opérationnel.
    document.body.appendChild(link);
    // Déclenchement d'un clic programmé sur le lien, ce qui lance le téléchargement du fichier.
    link.click();
    // Retrait du lien du DOM une fois le téléchargement initié.
    link.remove();
    // Libération de l'URL du blob pour éviter les fuites de mémoire.
    window.URL.revokeObjectURL(url);
  } catch (error) {
    // Enregistrement de l'erreur dans la console si le processus échoue.
    console.error('Erreur lors de l\'exportation :', error);
    // Relance de l'erreur pour éventuelle gestion supplémentaire.
    throw error;
  }
};

  
}


